// extracted by mini-css-extract-plugin
module.exports = {"root":"video_root__3t1LQ","video":"video_video__3it2L"};